export default "__VITE_ASSET__0113a775__"